import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import io from "socket.io-client";
import { getUserById, ReportUser } from "../api/api";
import socketServices from "../api/socket";
import { environment } from "../../environments/environments";
import "../../Component/CounsellorAllPages/CounsellorChat.css";
import Swal from "sweetalert2";

const CounsellorChatPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [currUser, setCurrUser] = useState(null);
  const [chatUser, setChatUser] = useState(null);
  const [sending, setSending] = useState(false);
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportMessageId, setReportMessageId] = useState(null);
  const [reportText, setReportText] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [emptyMessageModalVisible, setEmptyMessageModalVisible] =
    useState(false);
  const [token, setToken] = useState("");
  const flatListRef = useRef(null);

  useEffect(() => {
    socketServices.initializeSocket();
    const connectUser = async () => {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      setCurrUser(parsedUserData);
      if (parsedUserData) {
        socketServices.emit("userConnected", parsedUserData._id);
      }
    };
    connectUser();

    const messageListener = (data) => {
      setMessages((prevMessages) => [...prevMessages, data]);
    };

    socketServices.on("receiveMessage", messageListener);

    return () => {
      socketServices.emit("userDisconnected", currUser?._id);
    };
  }, []);

  useEffect(() => {
    socketServices.on("updateUserStatus", (data) => {
      if (data.userId === chatUser?._id) {
        setChatUser((prev) => ({ ...prev, status: data.status }));
      }
    });

    const storedToken = localStorage.getItem("jwtToken");
    console.log("sotredToken2222222", storedToken);
    if (storedToken) {
      setToken(storedToken);
    }

    const fetchCurrentUser = async () => {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      setCurrUser(parsedUserData);
      if (id) {
        const user = await getUserById({ user_id: id });
        setChatUser(user?.data);
      }
    };

    fetchCurrentUser();
  }, [id]);

  useEffect(() => {
    if (!currUser || !chatUser) return;

    const loadChats = async () => {
      try {
        const res = await fetch(
          `${environment.chatBaseUrl}/chats/${currUser._id || currUser.id}/${
            chatUser._id || chatUser.id
          }`
        );
        const chats = await res.json();
        console.log("all_Chat", chats);
        if (Array.isArray(chats) && chats.length === 0) {
          setEmptyMessageModalVisible(true);
        } else {
          setMessages([...chats]);
        }
      } catch (error) {
        console.error("Error fetching chats:", error);
      }
    };

    loadChats();
  }, [currUser, chatUser]);

  useEffect(() => {
    if (flatListRef.current) {
      flatListRef.current.scrollTop = flatListRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = async () => {
    if (!inputText.trim() || sending) return;
    setSending(true);

    const messageData = {
      from: currUser._id || currUser.id,
      to: id,
      msg: inputText.trim(),
      jwtsecret: token,
      connected_user_status: "approved",
      sender_id: currUser._id || currUser.id,
      chatmode: "counsellor",
    };
    console.log("messageData_send-message_api", messageData);

    try {
      // const response = await fetch(`${environment.chatBaseUrl}/send-message`, {
      const response = await fetch(environment?.chatBaseUrl + "/send-message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(messageData),
      });
      // const responseText = await response.text();
      // console.log("Server says:", responseText);
      // const responseData = await response.json();

      const responseData = await response.json();
      console.log("Server says:", responseData);

      if (responseData) {
        setInputText("");
        socketServices.emit("sendMessage", messageData);
      }
    } catch (error) {
      console.log("Error sending message:", error);
    } finally {
      setSending(false);
    }
  };

  const handleThreeDotPress = (messageId) => {
    setReportMessageId(messageId);
    setReportText("");
    setReportModalVisible(true);
  };

  const handleSubmitReport = async () => {
    const value = {
      user_id: currUser._id || currUser.id,
      reported_user_id: chatUser._id || chatUser.id,
      message_id: reportMessageId,
      description: reportText,
      reason: selectedReason,
      reported_type: "user",
      reporter_type: "counsellor",
    };
    console.log("repoert Value", value);
    try {
      const res = await ReportUser(value);
      console.log("resssssssss", res);
      if (res?.success) {
        // alert("Reported Successfully");
        Swal.fire({
          title: "Reported Successfully",
          text: res?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setReportModalVisible(false);
        setSelectedReason("");
      }
    } catch (error) {
      console.error("Report error:", error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong while reporting.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="cochat-container">
      <div className="cochat-header">
        {/* <button onClick={() => navigate(-1)}>← Back</button> */}
        <img
          src={`${environment.url}/uploads/users/${chatUser?.more_images?.[0]}`}
          alt="profile"
          className="coprofile-image"
        />
        <div>
          <h3>{chatUser?.name}</h3>
          {/* <p>{chatUser?.status === "Online" ? "🟢 Online" : "🔴 Offline"}</p> */}
        </div>
      </div>

      <div className="comessage-list" ref={flatListRef}>
        {messages.map((item, index) => {
          const currentuserid = currUser?._id || currUser?.id;
          const isSentByCurrentUser = item.sender_id === currentuserid;
          return (
            <div
              key={index}
              className={`comessage ${
                isSentByCurrentUser ? "sent" : "received"
              }`}
            >
              <div className="comessage-content">
                <p>{item?.msg}</p>
                <small>
                  {new Date(item.timestamp).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </small>
              </div>
              {!isSentByCurrentUser && (
                <button onClick={() => handleThreeDotPress(item._id)}>⋮</button>
              )}
            </div>
          );
        })}
      </div>

      <div className="cochat-input">
        <input
          type="text"
          placeholder="Type a message..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        />
        {inputText && <button onClick={sendMessage}>Send</button>}
      </div>

      {reportModalVisible && (
        <div className="comodal">
          <div className="comodal-content">
            <h3>Report Message</h3>
            <textarea
              placeholder="Enter reason for report..."
              value={reportText}
              onChange={(e) => setReportText(e.target.value)}
            />
            <div>
              {["Abuse", "Threat", "Violence", "Nudity", "Other"].map(
                (reason, i) => (
                  <label key={i}>
                    <input
                      type="radio"
                      value={reason}
                      checked={selectedReason === reason}
                      onChange={() => setSelectedReason(reason)}
                    />
                    {reason}
                  </label>
                )
              )}
            </div>
            <button
              onClick={handleSubmitReport}
              disabled={reportText.trim() === ""}
            >
              Submit
            </button>
            <button onClick={() => setReportModalVisible(false)}>Close</button>
          </div>
        </div>
      )}

      {emptyMessageModalVisible && (
        <div className="comodal">
          <div className="comodal-content">
            <h3>⚠️ Warning</h3>
            <ul>
              <li>Do not send empty messages.</li>
              <li>Avoid using abusive language.</li>
              <li>Threatening or violent messages are prohibited.</li>
              <li>Maintain respectful communication.</li>
            </ul>
            <button onClick={() => setEmptyMessageModalVisible(false)}>
              I Understand
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CounsellorChatPage;
